import React from "react";
import Cloud from "../../assets/icons/cloud.svg";
import ArrowNarrowUpRight from "../../assets/icons/arrow-narrow-up-right.svg";

export type IconName = "cloud" | "arrow-narrow-up-right";

const Icon: { [key in IconName]: React.FC<React.SVGProps<SVGSVGElement>> } = {
	cloud: Cloud,
	"arrow-narrow-up-right": ArrowNarrowUpRight,
};

type Props = {
	name: IconName;
} & React.SVGProps<SVGSVGElement>;

const GenemodIcon = ({ name, ...props }: Props) => {
	const SelectedIcon = Icon[name];
	return <SelectedIcon {...props} />;
};

export default GenemodIcon;
